// sv-SE
export default {
	title: "Presentkortcenter",
	myPoints: "Mina poäng",
	SelectedGifts: "Valda gåvor",
	form: {
		label: {
			title: "Sök",
			points: "Poäng"
		}
	},
	redemption: "Upprättelse",
	stock: "Stock",
	id: {
		redeemPoints: "Lösa in de nödvändiga poängen:",
		btn: "Lösa in nu",
		title: "Köpavisning",
		content: `Kära arbetare, tack för ditt deltagande i arbetet.\n\nLäs följande villkor innan du löser in poäng:\n\n[Arbetspoäng] Efter dagligt slutförande av orderuppsättningsdataoptimering kan arbetare tjäna 1 gåvopoäng, vilket kan användas för partiell inlösen av sponsring av gåvor.\n[Inlösen av gåvor] Arbetare måste ange relevant leveransadressinformation, och gåvan kommer att skickas gratis över hela världen inom 14 dagar. Efter att inlösen är klar kan du kontakta kundtjänst för att få spårningsnumret för att spåra gåvans framsteg. Plattformen kommer inte att avslöja information till tredje part.\nObs! När poängen har lösts in för gåvor kan de inte återbetalas`
	},
	applyDialog: {
		title: "Mottagande av information",
		form: {
			consignee: "Mottagare",
			area: "Område",
			telephone: "Telefon",
			deliveryAddress: "Leveransadress"
		},
		btn: "Skicka till"
	},
	records: {
		title: "Poster",
		status: ["Väntar på leverans", "Skickad", "Levererad", "Annullerad"]
	}
};
